const windowZaius = "zaius" in window ? window.zaius : null;

const zaiusUtility = {
    event(event_type, args_object) {
        if (!windowZaius) {
            return;
        }
        windowZaius.event(event_type, args_object);
    }
}

export default zaiusUtility;